import React, { createContext, useContext } from 'react'
import { type DocumentNode } from 'graphql'
import { Observable } from '@fs/zion-frontend-friends'

type ZionCMSContext = {
  customComponents?: Record<string, React.ElementType>
  customQueryMap?: Record<string, DocumentNode | undefined>
}

const ZionCMSContext = createContext<ZionCMSContext>({} as ZionCMSContext)

type ZionCMSProviderProps = {
  /**
   * An object map of custom components to be used when rendering ZionCMS components.
   */
  customComponents?: Record<string, React.ElementType>
  children: React.ReactNode
}

export default function ZionCMSProvider({ customComponents = {}, children }: ZionCMSProviderProps): JSX.Element {
  return (
    <ZionCMSContext.Provider value={{ customComponents }}>
      <Observable rootMargin="100px">{children}</Observable>
    </ZionCMSContext.Provider>
  )
}

export function useZionCMS(): ZionCMSContext {
  return useContext(ZionCMSContext)
}
